import Vue from "vue";
import Vuex, { Store } from "vuex";

import user from "./modules/user";
import enums from "./modules/enums";
import project from "./modules/project";
import synctask from "./modules/synctask";

import { isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";

Vue.use(Vuex);

const cacheKey = "__PROJECTDATA__";

const storedData = window.sessionStorage.getItem(cacheKey);
let storedState: any = null;
let start = false;

if (!isEmptyOrWhiteSpace(storedData)) {
  try {
    storedState = JSON.parse(storedData || "");
  } catch (e) {

  }
}

function persistencePlugin(store: Store<any>) {
  store.subscribe<{ type: string, payload: any }>(({ type, payload }) => {
    if (!start) {
      return;
    }
    const data = window.sessionStorage.getItem(cacheKey) || "{}";
    const state = Object.assign({}, JSON.parse(data));
    state[type] = payload;
    window.sessionStorage.setItem(cacheKey, JSON.stringify(state));
  });
}

const store = new Vuex.Store({
  state: {
    currentNavTitle: "",
    currentProject: null,
    isLoading: false
  },

  plugins: [persistencePlugin],

  mutations: {
    currentNavTitle(state, title) {
      state.currentNavTitle = title;
    },
    currentProject(state, project) {
      state.currentProject = project;
    },
    isLoading(state, value) {
      state.isLoading = value;
    }
  },
  actions: {},
  modules: { user, enums, project, synctask }
});

if (!isEmpty(storedState)) {
  Object.keys(storedState).forEach(type => store.commit(type, storedState[type]));
}
start = true;
export default store;
